import type {
  InboxConversation,
  Client,
  ProductItem,
  Campaign,
  Offer,
  KpiCard,
  HomeKpi,
  ThreadGroup,
  ThreadMessage,
  OnboardingStep,
  ActivityEvent,
  Notification,
  MockThread,
  CustomView,
  HunterContextMessage,
} from './types';

export const inboxConversations: InboxConversation[] = [
  { id: 'i1', name: 'Maria Lopez', avatar: 'ML', message: 'Interested in the Vitamin C Serum pricing', channel: 'whatsapp', time: '2m ago', unread: true, temperature: 'hot' },
  { id: 'i2', name: 'James Park', avatar: 'JP', message: 'Can you send the catalog?', channel: 'instagram', time: '15m ago', unread: true, temperature: 'warm' },
  { id: 'i3', name: 'Aisha Khan', avatar: 'AK', message: 'Thanks for the follow-up', channel: 'email', time: '1h ago', unread: false, temperature: 'warm' },
  { id: 'i4', name: 'Carlos Rivera', avatar: 'CR', message: 'When does the new collection drop?', channel: 'whatsapp', time: '3h ago', unread: true, temperature: 'hot' },
  { id: 'i5', name: 'Emily Chen', avatar: 'EC', message: 'Order received, thank you!', channel: 'email', time: '5h ago', unread: false, temperature: 'cold' },
];

export const clients: Client[] = [
  { id: 'c1', name: 'Maria Lopez', email: 'maria@example.com', avatar: 'ML', channel: 'whatsapp', value: 1240, status: 'active' },
  { id: 'c2', name: 'James Park', email: 'james@example.com', avatar: 'JP', channel: 'instagram', value: 890, status: 'active' },
  { id: 'c3', name: 'Aisha Khan', email: 'aisha@example.com', avatar: 'AK', channel: 'email', value: 2100, status: 'active' },
  { id: 'c4', name: 'Carlos Rivera', email: 'carlos@example.com', avatar: 'CR', channel: 'whatsapp', value: 560, status: 'new' },
  { id: 'c5', name: 'Emily Chen', email: 'emily@example.com', avatar: 'EC', channel: 'email', value: 3400, status: 'inactive' },
];

export const productItems: ProductItem[] = [
  { id: 'p1', name: 'Skin Type Quiz', type: 'quiz', status: 'live', leads: 142, revenue: 2140 },
  { id: 'p2', name: 'Routine Calculator', type: 'calculator', status: 'live', leads: 89, revenue: 1250 },
  { id: 'p3', name: 'Ingredient Guide', type: 'guide', status: 'draft', leads: 0, revenue: 0 },
  { id: 'p4', name: 'Skincare Assessment', type: 'assessment', status: 'live', leads: 56, revenue: 640 },
];

export const campaigns: Campaign[] = [
  { id: 'cp1', name: 'Summer Glow Launch', status: 'active', leads: 142, budget: 500, spent: 320, delta: '+12%' },
  { id: 'cp2', name: 'Re-engagement Wave', status: 'active', leads: 89, budget: 300, spent: 180, delta: '+8%' },
  { id: 'cp3', name: 'VIP Early Access', status: 'paused', leads: 56, budget: 200, spent: 95, delta: '-3%' },
  { id: 'cp4', name: 'Holiday Bundle Promo', status: 'draft', leads: 0, budget: 400, spent: 0 },
  { id: 'cp5', name: 'Spring Collection Tease', status: 'completed', leads: 210, budget: 350, spent: 350, delta: '+22%' },
];

export const homeCampaigns = campaigns;

export const offers: Offer[] = [
  { id: 'o1', productName: 'Skin Type Quiz', price: 0, type: 'free', status: 'active' },
  { id: 'o2', productName: 'Routine Calculator', price: 9.99, type: 'paid', status: 'active' },
  { id: 'o3', productName: 'Skincare Assessment', price: 29.99, type: 'subscription', status: 'active' },
  { id: 'o4', productName: 'Ingredient Guide', price: 4.99, type: 'paid', status: 'inactive' },
];

export const kpiCards: KpiCard[] = [
  { label: 'Revenue', value: '$4.2k', delta: '+12%', positive: true },
  { label: 'Leads', value: '342', delta: '+8%', positive: true },
  { label: 'Conv.', value: '4.7%', delta: '+0.3%', positive: true, ai: true },
  { label: 'Reply', value: '68%', delta: '-2%', positive: false },
];

export const homeKPIs: HomeKpi[] = [
  { label: "REVENUE", current: "$4.2k", projected: "$4.7k", direction: "up" as const },
  { label: "LEADS", current: "342", projected: "380", direction: "up" as const },
  { label: "CONV.", current: "4.7%", projected: null, direction: "neutral" as const },
  { label: "REPLY", current: "68%", projected: null, direction: "neutral" as const },
];

export const hunterActions = [
  "Responded to Maria Lopez on WhatsApp",
  "Sent follow-up to 2 warm leads",
  "Paused low-performing campaign",
];

export const threadGroups: ThreadGroup[] = [
  {
    label: 'Today',
    threads: [
      { id: 't1', name: 'WhatsApp follow-up sequence', cost: 6, active: true },
      { id: 't2', name: 'Lead analysis \u2014 Glow', cost: 4, active: false },
    ],
  },
  {
    label: 'Yesterday',
    threads: [
      { id: 't3', name: 'Campaign budget review', cost: 12, active: false },
      { id: 't4', name: 'Re-engagement strategy', cost: 8, active: false },
    ],
  },
  {
    label: 'Earlier',
    threads: [
      { id: 't5', name: 'ICP refinement', cost: 20, active: false },
      { id: 't6', name: 'Product launch plan', cost: 16, active: false },
    ],
  },
];

export const mockThreads: MockThread[] = [
  { id: 1, title: "Follow-up strategy", time: "2m", active: true },
  { id: 2, title: "Skincare quiz optimization", time: "1h", active: false },
  { id: 3, title: "Q1 campaign review", time: "3h", active: false },
  { id: 4, title: "Pricing analysis", time: "1d", active: false },
];

export const hunterContextByView: Record<string, HunterContextMessage> = {
  home: {
    message: "Maria replied \"interested\". Schedule a call?",
    actions: ["Schedule call", "View chat"],
  },
  inbox: {
    message: "4 conversations need follow-up. 2 VIPs.",
    actions: ["Show VIPs", "Draft replies"],
  },
  products: {
    message: "Skincare quiz: 12 completions today. +18%.",
    actions: ["View analytics", "Optimize quiz"],
  },
  campaigns: {
    message: "Re-engagement hit 70% budget. 3 days left.",
    actions: ["Adjust budget", "Pause campaign"],
  },
  insights: {
    message: "TikTok reel \u2192 45% of this week's leads.",
    actions: ["See breakdown", "Create campaign"],
  },
  sales: {
    message: "2 purchases today. $194 revenue.",
    actions: ["View orders", "Send receipts"],
  },
};

export const hunterChatMessages: ThreadMessage[] = [
  { role: 'assistant', text: 'I sent the follow-ups. Maria replied in 8 minutes.' },
  { role: 'user', text: 'Pause skincare campaign' },
  { role: 'assistant', text: 'Done. 1,200 credits saved.' },
  { role: 'assistant', text: 'Maria replied "interested".', quickReplies: ['Schedule call', 'View chat'] },
];

export const threadMessages: Record<string, ThreadMessage[]> = {
  t1: [
    { role: 'assistant', text: 'Hey \u2014 3 leads asked about pricing today' },
    { role: 'assistant', text: 'None of them have a follow-up yet' },
    { role: 'assistant', text: "Maria Lopez is the hottest one, she's been on the site 4 times this week" },
    { role: 'user', text: 'Set up a WhatsApp sequence for all 3' },
    { role: 'assistant', text: 'Done. 3 messages over 48h for each:' },
    { role: 'assistant', text: '1. Casual opener (in 2 hours)\n2. Value prop + social proof (tomorrow)\n3. Soft close with link (day after)', mono: true },
    { role: 'assistant', text: "First contact goes out at 5pm \u2014 want me to make Maria's more personal?", isRead: true },
    { role: 'user', text: 'Yes, make it conversational' },
    { role: 'assistant', text: "Changed Maria's opener:" },
    { role: 'assistant', text: "'Hey Maria, noticed you've been checking out the Vitamin C Serum \u2014 quick question: is your goal brightening or anti-aging?'", quote: true },
    { role: 'assistant', text: "Want me to recommend the Vitamin C + Niacinamide combo? It's your best seller for that.", isRead: true, quickReplies: ['Yes, recommend it', 'No, let me think', 'Show me the data first'] },
  ],
  t2: [
    { role: 'assistant', text: 'Quick update on Glow campaigns' },
    { role: 'assistant', text: '142 leads this month. Instagram is your top channel.' },
    { role: 'assistant', text: 'Women 25-34 convert at 6.2% \u2014 nearly double the average', isRead: true },
    { role: 'user', text: 'Focus next campaign on that segment' },
    { role: 'assistant', text: 'On it. Want me to draft a targeted campaign for 25-34 IG leads?' },
    { role: 'assistant', text: "I'd go with a 3-step sequence: quiz, guide, then soft pitch", isRead: true, actions: ['Draft campaign', 'Skip'] },
  ],
};

export const hunterInsight = 'Your WhatsApp reply rate dropped 4% this week. Leads from the Glow campaign respond best between 10am-12pm. Consider shifting send times to match.';

export const hunterBriefText = '3 leads waiting \u2014 Maria Lopez asked about pricing 2m ago';

export const hunterBriefEmptyText = 'No leads yet \u2014 launch a campaign to start capturing prospects';

export const onboardingSteps: OnboardingStep[] = [
  { id: 'ob1', label: 'Create workspace', done: true },
  { id: 'ob2', label: 'Set business profile', done: true },
  { id: 'ob3', label: 'Connect WhatsApp', done: false },
  { id: 'ob4', label: 'Define ICP', done: false },
  { id: 'ob5', label: 'Launch first campaign', done: false },
];

export const recentActivity: ActivityEvent[] = [
  { id: 'ra1', icon: 'msg', text: 'Maria Lopez responded on WhatsApp', time: '2m' },
  { id: 'ra2', icon: 'product', text: "Quiz 'Vitamin C' completed by 12 people", time: '15m' },
  { id: 'ra3', icon: 'ai', text: 'Auto-reply sent to Carlos Ruiz', time: '1h' },
  { id: 'ra4', icon: 'campaign', text: "Campaign 'Re-engagement' reached 50%", time: '3h' },
];

export const notifications: Notification[] = [
  { id: 'n1', text: 'Maria replied', time: '2m', unread: true, fromHunter: true },
  { id: 'n2', text: 'Campaign reached limit', time: '1h', unread: true, fromHunter: false },
  { id: 'n3', text: 'New lead from quiz', time: '3h', unread: false, fromHunter: false },
];

export const mockCustomViews: CustomView[] = [
  { id: 1, title: "Revenue Projection Q2", type: "chart", icon: "bar-chart", createdAt: "2 days ago" },
  { id: 2, title: "Google Ads CPL by Campaign", type: "table", icon: "table", createdAt: "1 week ago" },
];

export const emptyStateCopy: Record<string, { text: string; cta: string }> = {
  inbox: { text: "No conversations yet", cta: "Start a campaign to generate leads" },
  products: { text: "No products yet", cta: "Create with Hunter \u2192" },
  campaigns: { text: "No campaigns yet", cta: "Launch your first campaign \u2192" },
  insights: { text: "No data yet", cta: "Connect a channel to start tracking \u2192" },
  sales: { text: "No sales yet", cta: "Create your first offer \u2192" },
};
